let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'
export { urlAlphabet }



//////////////////
// WEBPACK FOOTER
// ./~/nanoid/url-alphabet/index.js
// module id = 702
// module chunks = 14